import { render, staticRenderFns } from "./supportersPointListModal.vue?vue&type=template&id=5c2a83ae&"
import script from "./supportersPointListModal.vue?vue&type=script&lang=js&"
export * from "./supportersPointListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports